// @flow
import React, { createContext, useReducer, type Node } from 'react';

export type CriteriaContextValuesType = {
  criteriaWhenIsSet: boolean,
  criteriaWhoIsSet: boolean,
  criteriaTransportIsSet: boolean,
  defaultValueForCalendar: ?moment$Moment,
  isJoyview: boolean,
  layerButtonLabel: string,
  layerHeader: string | Node,
  trackingActionName: string,
};

export const initialState = {
  criteriaWhenIsSet: false,
  criteriaWhoIsSet: false,
  criteriaTransportIsSet: false,
  defaultValueForCalendar: null,
  isJoyview: false,
  layerButtonLabel: '',
  layerHeader: '',
  trackingActionName: '',
};

type CriteriaContextAction = $Shape<CriteriaContextValuesType>;
const criteriaContextReducer = (state, action: CriteriaContextAction) => {
  return { ...state, ...action };
};

type CriteriaContextType = [CriteriaContextValuesType, (CriteriaContextAction) => void];

export const CriteriaContext = createContext<CriteriaContextType>([initialState, () => {}]);
export const CriteriaContextProvider = ({
  children,
  value = {},
}: {
  children: Node,
  value?: $Shape<CriteriaContextValuesType>,
}) => {
  const [state, dispatch] = useReducer(criteriaContextReducer, { ...initialState, ...value });
  return <CriteriaContext.Provider value={[state, dispatch]}>{children}</CriteriaContext.Provider>;
};
